<div class="container text-center mt-4">
  <div class="row">
    <div class="col text-start card-background p-4">
      <div class="card">
        <div class="container">
          <div class="row">
            <div class="col">
              <h1>Contact Us</h1>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <form [formGroup]="contactForm">
                <div class="mb-3">
                  <label for="selectHelpPrompt" class="form-label">How can we help?</label>
                  <select id="selectHelpPrompt" name="selectHelpPrompt" class="form-select" aria-label="How can we help?"
                    [formControl]="this.contactForm.controls.firstOptionsSet" (change)="handleFirstOptionsSetChange()" (blur)="handleFirstOptionsSetChange()">
                    <option selected value="">Select one</option>
                    <option value="1">I am requesting MealPlanner account information</option>
                    <option value="2">I want to ask a question regarding privacy on MealPlanner</option>
                    <option value="3">I need help logging into my account</option>
                    <option value="4">I need assistance with a locked or suspended account</option>
                    <option value="5">I need help with paid features</option>
                  </select>
                  <div
                    *ngIf="this.contactForm.controls.firstOptionsSet.invalid && (this.contactForm.controls.firstOptionsSet.dirty || this.contactForm.controls.firstOptionsSet.touched)"
                    class="alert alert-danger">
                    <div *ngIf="this.contactForm.controls.firstOptionsSet.hasError('required')">
                      Please make a selection from the list of options.
                    </div>
                    <div *ngIf="this.contactForm.controls.firstOptionsSet.hasError('min') || this.contactForm.controls.firstOptionsSet.hasError('max')">
                      Please select a valid option from the list of options.
                    </div>
                  </div>
                </div>

                <div class="mb-3 d-none" id="divAccountInformationOptions">
                  <label for="accountInformationOptionsSet" class="form-label">Who does the MealPlanner account belong to?</label>
                  <select id="accountInformationOptionsSet" name="accountInformationOptionsSet" class="form-select" aria-label="Default select example"
                    [formControl]="this.contactForm.controls.accountInformationOptionsSet" (change)="handleAcctInfoOptionsSetChange()" value="0">
                    <option selected value="">Select one</option>
                    <option value="1">The MealPlanner account is mine</option>
                    <option value="2">The MealPlanner account belongs to someone else</option>
                  </select>
                  <div
                    *ngIf="this.contactForm.controls.accountInformationOptionsSet.invalid && (this.contactForm.controls.accountInformationOptionsSet.dirty || this.contactForm.controls.accountInformationOptionsSet.touched)"
                    class="alert alert-danger">
                    <div *ngIf="this.contactForm.controls.accountInformationOptionsSet.hasError('required')">
                      Please make a selection from the list of options.
                    </div>
                    <div
                      *ngIf="this.contactForm.controls.accountInformationOptionsSet.hasError('min') || this.contactForm.controls.accountInformationOptionsSet.hasError('max')">
                      Please select a valid option from the list of options.
                    </div>
                  </div>
                </div>

                <app-privacy-questions></app-privacy-questions>

                <div class="mb-3 d-none" id="divMyAccountInformationOptions">
                  <label for="myAccountInformationOptionsSet" class="form-label">Tell us how we can help with your account information</label>
                  <select id="myAccountInformationOptionsSet" name="myAccountInformationOptionsSet" class="form-select" aria-label="Default select example"
                    [formControl]="this.contactForm.controls.myAccountInformationOptionsSet" (change)="handleMyAcctInfoOptionsSetChange()" value="0">
                    <option selected value="">Select one</option>
                    <option value="1">I am requesting assistance with account recovery for my MealPlanner account.</option>
                    <option value="2">I'm having trouble using MealPlanner.</option>
                    <option value="3">I would like to retrieve my MealPlanner data.</option>
                  </select>
                  <div
                    *ngIf="this.contactForm.controls.myAccountInformationOptionsSet.invalid && (this.contactForm.controls.myAccountInformationOptionsSet.dirty || this.contactForm.controls.myAccountInformationOptionsSet.touched)"
                    class="alert alert-danger">
                    <div *ngIf="this.contactForm.controls.myAccountInformationOptionsSet.hasError('required')">
                      Please make a selection from the list of options.
                    </div>
                    <div
                      *ngIf="this.contactForm.controls.myAccountInformationOptionsSet.hasError('min') || this.contactForm.controls.myAccountInformationOptionsSet.hasError('max')">
                      Please select a valid option from the list of options.
                    </div>
                  </div>
                </div>

                <div class="mb-3 d-none" id="divSomeOneElsesInformation">
                  <div class="card card-someone-elses-information">
                    <h5 class="card-header">About access to account information that belongs to someone else</h5>
                    <div class="card-body">
                      <h5 class="card-title">For individual requests:</h5>
                      <p class="card-text">Just a heads-up, Meal Planner can only share account data with the actual account holder or an authorized representative.
                      </p>
                      <p>Need help with a hacked account, password troubles, or deactivating/reactivating? No worries! Just use this <a
                          href="/password_reset">form</a> to
                        get the assistance you need.</p>
                    </div>
                  </div>
                </div>

                <p id="myAccountOptionOneResponse" class="d-none">
                  If you need help with your account (hacking, password issues, deactivation/reactivation), submit a request through this <a
                    href="/password_reset">link</a> instead.
                </p>

                <p id="myAccountOptionTwoResponse" class="d-none">
                  For help with using MealPlanner, please visit our <a href="/help_center">Help Center</a>.
                </p>

                <app-retrieve-my-data id="myAccountOptionThreeResponse" class="d-none"></app-retrieve-my-data>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
